import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { testConfig } from '../../docs-routes'

const TestResultsStep = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Step logs show you information about the execution of each step in a test config, which can help in troubleshooting.
    </Color>
    <DocusaurusFooter path={testConfig} />
  </Paragraph>

export default TestResultsStep
